import { Separator } from "@/shared/ui/separator";
import { useTranslation } from "@/shared/i18n";

import {
  RichText,
  TutorialLayout,
  TutorialScreenshot,
  TutorialStep,
  TutorialTip,
} from "../components/TutorialBlocks";
import { tutorialImage } from "../lib/tutorialImages";

const STEPS = [
  { key: "step1", image: "add-template/step1.webp" },
  { key: "step2", image: "add-template/step2.webp" },
  { key: "step3", image: "add-template/step3.webp", hasBody2: true },
  { key: "step4", image: "add-template/step4.webp", hasTip: true },
  { key: "step5", image: "add-template/step5.webp", hasBody2: true },
  { key: "step6", image: "add-template/step6.webp" },
  { key: "step7", image: "add-template/step7.webp" },
];

export default function TutorialAddTemplatePage() {
  const { t } = useTranslation("psdTutorials");

  return (
    <TutorialLayout title={t("addTemplate.pageTitle")} subtitle={t("addTemplate.subtitle")}>
      <div className="space-y-8 pb-12">
        <div>
          {STEPS.map((step, index) => (
            <TutorialStep
              key={step.key}
              number={index + 1}
              title={t(`addTemplate.${step.key}.title`)}
              isLast={index === STEPS.length - 1}
            >
              <p>
                <RichText i18nKey={`addTemplate.${step.key}.body`} />
              </p>
              {step.hasBody2 && (
                <p>
                  <RichText i18nKey={`addTemplate.${step.key}.body2`} />
                </p>
              )}
              <div className="pt-2">
                <TutorialScreenshot
                  src={tutorialImage(step.image)}
                  alt={t(`addTemplate.${step.key}.title`)}
                  caption={t(`addTemplate.${step.key}.caption`)}
                />
              </div>
              {step.hasTip && (
                <div className="pt-2">
                  <TutorialTip>
                    <RichText i18nKey={`addTemplate.${step.key}.tip`} />
                  </TutorialTip>
                </div>
              )}
            </TutorialStep>
          ))}
        </div>

        <Separator />

        <section>
          <div className="mb-1.5 font-mono text-xs uppercase tracking-widest text-primary">
            {t("addTemplate.categories.label")}
          </div>
          <h2 className="mb-4 border-b border-border pb-3 text-xl font-semibold text-foreground">
            {t("addTemplate.categories.title")}
          </h2>
          <p className="mb-5 text-sm text-muted-foreground">
            <RichText i18nKey="addTemplate.categories.intro" />
          </p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <div className="mb-2 font-mono text-xs uppercase tracking-wider text-primary">
                {t("addTemplate.categories.listLabel")}
              </div>
              <TutorialScreenshot
                src={tutorialImage("add-template/step8.webp")}
                alt={t("addTemplate.categories.listLabel")}
                caption={t("addTemplate.categories.listCaption")}
              />
            </div>
            <div>
              <div className="mb-2 font-mono text-xs uppercase tracking-wider text-primary">
                {t("addTemplate.categories.actionsLabel")}
              </div>
              <TutorialScreenshot
                src={tutorialImage("add-template/step9.webp")}
                alt={t("addTemplate.categories.actionsLabel")}
                caption={t("addTemplate.categories.actionsCaption")}
              />
            </div>
          </div>
        </section>
      </div>
    </TutorialLayout>
  );
}
